import React, { useMemo } from "react";
import { Route, Routes } from "react-router-dom";

import Footer from "./navbars/Footer";
import Header from "./navbars/Header";

import ScrollToTop from "./scrollToTop";

// DAQAstra is now an external link - imports commented out
// import { daqastraData } from "./daqastra/DaqastraData";
// import { DAQFooter } from "./daqastra/Specs";
// import { SpecsFooter } from "./daqastra/SpecsFooter";
// import { SpecsTables } from "./daqastra/SpecsTable";
import CapabilitiesPage from "./capabilities/CapabilitiesPage";
import RnDPage from "./rnd/RnDPage";
import { companyData } from "./company/CompanyData";
import { Facilities } from "./company/Facilities";
import { Observatories } from "./company/Observatories";
import { TeamPage } from "./company/TeamPage";
import { StandardPage } from "./components/StandardPage";
// import { DaqPage } from "./components/DaqPage"; // DAQAstra now external
import { ContactPage } from "./contact/ContactPage";
import { navLinks } from "./navData";
import { NewsComponent } from "./news/NewsComponent";
import { newsMap } from "./news/newsData";
import { productsData } from "./products/ProductsData";
import TKOPage from "./products/TKOPage";
import TheiaPage from "./products/TheiaPage";
import CaptureBagPage from "./products/CaptureBagPage";
import DaqastraPage from "./products/DaqastraPage";
import SplashPage from "./splash/Container";



const AppShell = () => {
  const pageMapping = useMemo(
    () => ({
      capabilities: {
        index: <CapabilitiesPage />,
      },
      rnd: {
        index: <RnDPage />,
      },
      products: {
        tko: <TKOPage />,
        // accutilt: <StandardPage data={productsData.accutilt} />,
        theia: <TheiaPage />,
        capturebag: <CaptureBagPage />,
        daqastra: <DaqastraPage />,
      },
      company: {
        team: <TeamPage data={companyData.team} />,
        facilities: <Facilities data={companyData.facilities} />,
        observatories: <Observatories data={companyData.observatories} />,
      },
      news: {
        featured: <NewsComponent type={newsMap.featured} />,
        articles: <NewsComponent type={newsMap.articles} />,
        videos: <NewsComponent type={newsMap.videos} />,
        podcasts: <NewsComponent type={newsMap.podcasts} />,
        publicAppearances: <NewsComponent type={newsMap.publicAppearances} />,
      },
      // daqastra: { // DAQAstra now links to external site
      //   overview: <StandardPage data={daqastraData.overview} />,
      //   specs: (
      //     <>
      //       <DAQFooter data={daqastraData.specs} />
      //       <SpecsTables />,
      //       <SpecsFooter />
      //     </>
      //   ),
      //   caseStudies: (
      //     <>
      //       {daqastraData.case.map((caseStudy, i) => (
      //         <DaqPage key={i} data={caseStudy} />
      //       ))}
      //     </>
      //   ),
      // },
      contact: {
        index: <ContactPage />,
      },
    }),
    []
  );

  return (
    <>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route exact path="/" element={<SplashPage />} />
        {Object.values(navLinks)
          .filter((pageData) => !pageData.externalUrl)
          .map((pageData) => (
          <Route key={pageData.link} path={pageData.link}>
            {pageData.dropdowns && pageData.link !== "capabilities" && pageData.link !== "rnd" ? (
              Object.values(pageData.dropdowns).map((dropdownData) => (
                <Route
                  key={pageData.name + dropdownData.link}
                  path={dropdownData.link}
                  element={pageMapping[pageData.link][dropdownData.link]}
                />
              ))
            ) : (
              <Route index element={pageMapping[pageData.link].index} />
            )}
          </Route>
        ))}
      </Routes>
      <Footer />
    </>
  );
};

export default AppShell;
